// Module
var code = "<md-content class=\"animated fadeIn\"> <div ng-style=\"{height: $ctrl.screenSize.height + 'px'}\" layout=\"row\" layout-align=\"center center\"> <p>{{$ctrl.msg}}</p> </div> </md-content>";
// Exports
export default code;